import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Mission from "./components/Mission";
import Council from "./components/Council";
import Approach from "./components/Approach"; 
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";


function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Mission />
      <Council />
      <Approach />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;